import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { addToCart, reRenderShopifySections } = utils

class HHProductCard extends LitElement {
  static properties = {
    canAddToCart: {
      type: Boolean,
      attribute: 'add-to-cart',
      reflect: true,
    },
    active: {
      type: Boolean,
      reflect: true,
    },
    mobileActive: {
      type: Boolean,
      reflect: true,
      attribute: 'mobile-active',
    },
    hasSize: {
      type: Boolean,
      attribute: 'has-size',
    },
    isCartPage: {
      type: Boolean,
      attribute: 'is-cart-page',
      reflect: true,
    },
  }

  constructor() {
    super()

    this.active = false
  }

  connectedCallback() {
    super.connectedCallback()

    this._toggleEventListeners(true)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this._toggleEventListeners(false)
  }

  _toggleEventListeners(flag) {
    if (this.canAddToCart) {
      document.body[`${flag ? 'add' : 'remove'}EventListener`](
        'click',
        this.handleBodyClick.bind(this)
      )

      this.querySelectorAll('[data-variant-id]').forEach((button) => {
        button[`${flag ? 'add' : 'remove'}EventListener`](
          'click',
          this.onClickHandler.bind(this)
        )
      })
    }
  }

  async onClickHandler(event) {
    event.preventDefault()
    const { target } = event
    if (target.hasAttribute('data-mobile-quick-add-toggle')) {
      this.toggleQuickAdd(event)
      return
    }

    this.classList.add('loading')

    const sections = this.isCartPage ? 'inline-cart,header' : 'mini-cart,header'

    reRenderShopifySections(
      await addToCart(
        {
          id: target.dataset.variantId,
          quantity: 1,
        },
        sections
      )
    )

    this.classList.remove('loading')
    this.mobileActive && this.toggleQuickAdd(event)

    document.body.classList.add('mini-cart-is-active')

    document.querySelectorAll('s-header').forEach(header => {
      header.connectedCallback();
    });
  }

  handleBodyClick(e) {
    const path = e.path || (e.composedPath && e.composedPath())
    if (
      path.some((node) => {
        return node === this
      })
    ) {
      return true
    }

    this.active = false
  }

  toggleQuickAdd(event) {
    event.preventDefault()
    const { target } = event

    this.mobileActive = !this.mobileActive
    target.setAttribute('aria-expanded', this.mobileActive)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card', HHProductCard)
